<template>
  <v-col cols="10">
    <v-btn v-if="pickerMode" icon dark>
      <v-icon>
        {{
          isChosen ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-unmarked-outline'
        }}
      </v-icon>
    </v-btn>
    <v-btn v-else-if="!hideDelete" icon @click.stop.prevent="$emit('remove-file', file.id)">
      <v-icon>mdi-close-circle-outline</v-icon>
    </v-btn>
    <audio controls>
      <source
        :src="file.url"
        :type="`audio/${file.format}`"
      >
    </audio>
    <slot name="body"/>
  </v-col>
</template>

<script>
export default {
  name: 'media-preview-AUDIO',
  props: {
    file: {
      type: Object,
      default: () => ({}),
      required: true
    },
    isChosen: {
      type: Boolean,
      default: false
    },
    hideDelete: {
      type: Boolean,
      default: false
    },
    pickerMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>
